// Configuration SEO centralisée — WYVIO.
// Source unique de vérité pour titles, descriptions, keywords et JSON-LD
// injectés côté client via React-Helmet.

const SITE_URL = "https://wyvio.app";
const SITE_NAME = "WYVIO";
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;

export const seoConfig = {
  siteUrl: SITE_URL,
  siteName: SITE_NAME,
  defaultOgImage: DEFAULT_OG_IMAGE,

  pages: {
    home: {
      path: "/",
      title: "WYVIO · Toute votre relation client. Une seule plateforme.",
      description:
        "WYVIO centralise et sécurise le suivi client des professionnels de l'automobile. Gagnez du temps, sécurisez vos échanges, gardez une traçabilité complète.",
      keywords: [
        "WYVIO",
        "plateforme relation client automobile",
        "suivi client automobile",
        "traçabilité",
        "gain de temps",
        "sécurisation des échanges",
        "transparence",
        "historisation",
      ],
    },
    fonctionnalites: {
      path: "/fonctionnalites",
      title: "Fonctionnalités · WYVIO",
      description:
        "Timeline, documents, photos, SMS, emails, notifications, SAV, livraison, historique permanent. Découvrez comment WYVIO centralise toute votre relation client.",
      keywords: [
        "fonctionnalités WYVIO",
        "timeline dossier",
        "historique client",
        "notifications automatiques",
        "traçabilité complète",
      ],
    },
    tarifs: {
      path: "/tarifs",
      title: "Tarifs · WYVIO",
      description:
        "Une offre transparente pour les équipes qui veulent gagner du temps et sécuriser leurs échanges. Grille tarifaire en cours de finalisation — contactez-nous pour un accès prioritaire.",
      keywords: ["tarifs WYVIO", "prix plateforme relation client", "abonnement WYVIO"],
    },
    aPropos: {
      path: "/a-propos",
      title: "À propos · WYVIO",
      description:
        "WYVIO existe pour une raison simple : plus rien ne doit se perdre. Découvrez notre approche du calme par la structure.",
      keywords: ["à propos WYVIO", "mission WYVIO", "vision WYVIO"],
    },
    contact: {
      path: "/contact",
      title: "Contact · WYVIO",
      description:
        "Une question sur WYVIO, une demande de démonstration ou un déploiement pour votre équipe ? Écrivez-nous.",
      keywords: ["contact WYVIO", "démonstration WYVIO", "démo relation client"],
    },
    mentionsLegales: {
      path: "/mentions-legales",
      title: "Mentions légales · WYVIO",
      description:
        "Mentions légales du service WYVIO : éditeur, hébergement, données personnelles, cookies.",
      keywords: ["mentions légales WYVIO"],
    },
  },
};

// ────────────────────────────────────────────────────────────────
// JSON-LD builders — enrichissent chaque page indexable
// ────────────────────────────────────────────────────────────────

export const jsonLdOrganization = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  name: SITE_NAME,
  url: SITE_URL,
  logo: `${SITE_URL}/logo.png`,
  description: seoConfig.pages.home.description,
  sameAs: [],
});

export const jsonLdWebsite = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: SITE_NAME,
  url: SITE_URL,
  inLanguage: "fr-FR",
  publisher: { "@type": "Organization", name: SITE_NAME },
});

export const jsonLdSoftwareApplication = () => ({
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  name: SITE_NAME,
  applicationCategory: "BusinessApplication",
  operatingSystem: "Web",
  url: SITE_URL,
  description: seoConfig.pages.home.description,
});

export const jsonLdBreadcrumb = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${SITE_URL}${it.path}`,
  })),
});

export const jsonLdFAQ = (faq) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faq.map((q) => ({
    "@type": "Question",
    name: q.question,
    acceptedAnswer: { "@type": "Answer", text: q.answer },
  })),
});

export default seoConfig;
